"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var Variant = function Variant(_ref) {
  var children = _ref.children;
  return children;
};

Variant.propTypes = {
  variant: _propTypes.string.isRequired,
  children: _propTypes.node.isRequired
};
var _default = Variant;
exports.default = _default;